import { render, staticRenderFns } from "./NewExpense.vue?vue&type=template&id=6c97ab71&scoped=true&"
import script from "./NewExpense.vue?vue&type=script&lang=ts&"
export * from "./NewExpense.vue?vue&type=script&lang=ts&"
import style0 from "./NewExpense.vue?vue&type=style&index=0&id=6c97ab71&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c97ab71",
  null
  
)

export default component.exports